import { gql } from "@apollo/client";

export const INFRA_VIEWS = gql`
  mutation FetchInfraViews(
    $page: Int
    $limit: Int
    $entity_type: String
    $status: [String]
    $integrationKey: String!
    $framework_id: Int!
  ) {
    fetchInfraViews(
      page: $page
      limit: $limit
      filter: {
        entity_type: $entity_type
        status: $status
        integrationKey: $integrationKey
        framework_id: $framework_id
      }
    ) {
      message
      metadata {
        totalRecords
        totalPassRecords
        totalFailRecords
        totalDisabledRecords
        totalPages
        currentPage
        limit
        group {
          entity_name
          entity_type
        }
      }
      data {
        check_name
        check_id
        entity_type
        entity_name
        resource_name
        check_description
        account_id
        resource_id
        status
        status_reason
      }
    }
  }
`;
export const GET_AWS_CHECK_EXCEPTIONS = gql`
  query getAwsCheckExceptions($filter: AwsCheckExceptionFilterInput, $page: Int, $limit: Int) {
    getAwsCheckExceptions(filter: $filter, page: $page, limit: $limit) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
        is_active
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_AWS_CHECK_EXCEPTION_BY_ID = gql`
  query getAwsCheckExceptionById($id: Int!) {
    getAwsCheckExceptionById(id: $id) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
        is_active
      }
    }
  }
`;

export const CREATE_AWS_CHECK_EXCEPTION = gql`
  mutation createAwsCheckException($exception_data: AwsCheckExceptionInput!) {
    createAwsCheckException(exception_data: $exception_data) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
      }
    }
  }
`;

export const UPDATE_AWS_CHECK_EXCEPTION = gql`
  mutation updateAwsCheckException(
    $id: Int!
    $update_data: AwsCheckExceptionUpdateInput!
  ) {
    updateAwsCheckException(id: $id, update_data: $update_data) {
      success
      message
      data {
        id
        reason
        exception_valid_till
      }
    }
  }
`;

export const DELETE_AWS_CHECK_EXCEPTION = gql`
  mutation deleteAwsCheckException($ids: [Int!]!) {
    deleteAwsCheckException(ids: $ids) {
      success
      message
      data {
        id
      }
    }
  }
`;

export const GET_AZURE_CHECK_EXCEPTIONS = gql`
  query getAzureCheckExceptions($filter: AzureCheckExceptionFilterInput, $page: Int, $limit: Int) {
    getAzureCheckExceptions(filter: $filter, page: $page, limit: $limit) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
        is_active
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_AZURE_CHECK_EXCEPTION_BY_ID = gql`
  query getAzureCheckExceptionById($id: Int!) {
    getAzureCheckExceptionById(id: $id) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
      }
    }
  }
`;

export const CREATE_AZURE_CHECK_EXCEPTION = gql`
  mutation createAzureCheckException(
    $exception_data: AzureCheckExceptionInput!
  ) {
    createAzureCheckException(exception_data: $exception_data) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
      }
    }
  }
`;

export const UPDATE_AZURE_CHECK_EXCEPTION = gql`
  mutation updateAzureCheckException(
    $id: Int!
    $update_data: AzureCheckExceptionUpdateInput!
  ) {
    updateAzureCheckException(id: $id, update_data: $update_data) {
      success
      message
      data {
        id
        reason
        exception_valid_till
      }
    }
  }
`;

export const DELETE_AZURE_CHECK_EXCEPTION = gql`
  mutation deleteAzureCheckException($ids: [Int!]!) {
    deleteAzureCheckException(ids: $ids) {
      success
      message
      data {
        id
      }
    }
  }
`;

export const GET_REMEDIATION_PLAN = gql`
  query getRemediationPlan(
    $check_id: Int!
    $resource_ids: [String]
    $overrides: JSON
  ) {
    getRemediationPlan(
      check_id: $check_id
      resource_ids: $resource_ids
      overrides: $overrides
    ) {
      success
      message
      checkType
      cloud
      hasCommand
      remediationEnabled
      resources {
        resourceId
        resourceKey
        resourceName
        accountId
        command
        isComplete
        missing {
          key
          description
          note
        }
      }
      missing {
        key
        description
        note
      }
      consoleSteps
      savedInputs
      fetchChoices
      fetchHints
      warning
    }
  }
`;

export const SAVE_REMEDIATION_INPUTS = gql`
  mutation saveRemediationInputs(
    $check_id: Int!
    $resource_id: String
    $account_id: String
    $inputs: JSON!
  ) {
    saveRemediationInputs(
      check_id: $check_id
      resource_id: $resource_id
      account_id: $account_id
      inputs: $inputs
    ) {
      success
      message
    }
  }
`;

export const CLEAR_REMEDIATION_INPUTS = gql`
  mutation clearRemediationInputs(
    $check_id: Int!
    $resource_id: String
    $account_id: String
    $resource_ids: [String]
  ) {
    clearRemediationInputs(
      check_id: $check_id
      resource_id: $resource_id
      account_id: $account_id
      resource_ids: $resource_ids
    ) {
      success
      message
    }
  }
`;

export const GET_AWS_RESOURCE_BY_CHECK_ID = gql`
  query getAwsResourceByCheckId($check_id: Int!, $start_time: DateTime, $end_time: DateTime, $audit_id: String) {
    getAwsResourceByCheckId(check_id: $check_id, start_time: $start_time, end_time: $end_time, audit_id: $audit_id) {
      id
      check_id
      entity_type
      entity_name
      resource_name
      account_id
      resource_id
      status
      status_reason
      policy_execution_time
    }
  }
`;

export const GET_AZURE_RESOURCE_BY_CHECK_ID = gql`
  query getAzureResourceByCheckId($check_id: Int!, $start_time: DateTime, $end_time: DateTime, $audit_id: String) {
    getAzureResourceByCheckId(check_id: $check_id, start_time: $start_time, end_time: $end_time, audit_id: $audit_id) {
      id
      check_id
      entity_type
      entity_name
      resource_name
      account_id
      resource_id
      status
      status_reason
      policy_execution_time
    }
  }
`;

export const GET_GCP_CHECK_EXCEPTIONS = gql`
  query getGcpCheckExceptions($filter: GcpCheckExceptionFilterInput, $page: Int, $limit: Int) {
    getGcpCheckExceptions(filter: $filter, page: $page, limit: $limit) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
        is_active
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_GCP_CHECK_EXCEPTION_BY_ID = gql`
  query getGcpCheckExceptionById($id: Int!) {
    getGcpCheckExceptionById(id: $id) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
        is_active
      }
    }
  }
`;

export const CREATE_GCP_CHECK_EXCEPTION = gql`
  mutation createGcpCheckException($exception_data: GcpCheckExceptionInput!) {
    createGcpCheckException(exception_data: $exception_data) {
      success
      message
      data {
        id
        active_check_id
        scope
        account_id
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        created_at
      }
    }
  }
`;

export const UPDATE_GCP_CHECK_EXCEPTION = gql`
  mutation updateGcpCheckException(
    $id: Int!
    $update_data: GcpCheckExceptionUpdateInput!
  ) {
    updateGcpCheckException(id: $id, update_data: $update_data) {
      success
      message
      data {
        id
        reason
        exception_valid_till
      }
    }
  }
`;

export const DELETE_GCP_CHECK_EXCEPTION = gql`
  mutation deleteGcpCheckException($ids: [Int!]!) {
    deleteGcpCheckException(ids: $ids) {
      success
      message
      data {
        id
      }
    }
  }
`;

export const GET_GCP_RESOURCE_BY_CHECK_ID = gql`
  query getGcpResourceByCheckId($check_id: Int!, $start_time: DateTime, $end_time: DateTime, $audit_id: String) {
    getGcpResourceByCheckId(check_id: $check_id, start_time: $start_time, end_time: $end_time, audit_id: $audit_id) {
      id
      check_id
      entity_type
      entity_name
      resource_name
      account_id
      resource_id
      status
      status_reason
      policy_execution_time
    }
  }
`;

export const GET_INTEGRATION_DETAILS = gql`
  query GetIntegrationDetails($integrationKey: String!) {
    getIntegrationDetails(integrationKey: $integrationKey) {
      success
      message
      data {
        id
        is_active
        inactivity_reason
        account_id
        updated_at
        run_status
      }
    }
  }
`;

export const GET_INFRA_INTEGRATION_LEVEL_SUMMARY = gql`
  query GetInfraIntegrationLevelSummary($framework_id: Int) {
    getInfraIntegrationLevelSummary(framework_id: $framework_id) {
      success
      message
      data {
        integration
        totalAccounts
        totalChecksApplicable
        compliancePercent
        checksSummary {
          passingChecks
          failingChecks
          disabledChecks
          pendingChecks
        }
      }
    }
  }
`;

export const GET_INFRA_CHECKS = gql`
  query GetInfraChecks($page: Int, $limit: Int, $filter: InfraFilterInput) {
    getInfraChecks(page: $page, limit: $limit, filter: $filter) {
      success
      message
      data {
        active_check_id
        active_check_name
        active_check_description
        status
        check_type
        entity_type
      }
      metadata {
        totalRecords
        totalPages
      }
    }
  }
`;

export const GENERATE_INFRA_CHECKS_EXCEL = gql`
  mutation GenerateInfraChecksExcel(
    $framework_id: Int!
    $active_check_category: [String]!
    $status: [String]
    $entity_type: [String]
  ) {
    generateInfraChecksExcel(
      framework_id: $framework_id
      active_check_category: $active_check_category
      status: $status
      entity_type: $entity_type
    ) {
      url
    }
  }
`;

export const GET_CHECK_ACTIVITY_HISTORY = gql`
  query getCheckActivityHistory(
    $check_id: Int!
    $audit_id: String
    $start_time: DateTime
    $end_time: DateTime
  ) {
    getCheckActivityHistory(
      check_id: $check_id
      audit_id: $audit_id
      start_time: $start_time
      end_time: $end_time
    ) {
      date
      run_time
      status
      status_reason
    }
  }
`;
